import React from 'react';
import { node, string } from 'prop-types';
import { transformCurrencies } from '../../../utils/currency';
import { HEADER_SOURCE, PACKAGE_CLASSNAME } from '../../../constants';
import { DEFAULT_STYLE, LINK_CLASSNAME, LINK_TITLE_CLASSNAME } from '../constants';
import { useHeaderContext } from '../../../modern/context/HeaderContext';

const CurrencyLink = ({ style = DEFAULT_STYLE, Component }) => {
    const { currency, supportedCurrencies, user, rollouts } = useHeaderContext();
    const props = {
        currency: currency?.code,
        user,
        style,
        className: LINK_CLASSNAME,
        titleClassName: LINK_TITLE_CLASSNAME,
        modalClassName: PACKAGE_CLASSNAME,
        supportedCurrencies: transformCurrencies(supportedCurrencies),
        source: HEADER_SOURCE,
        rollouts,
    };

    return <Component {...props} />;
};

CurrencyLink.propTypes = {
    style: string,
    Component: node.isRequired,
};

export default CurrencyLink;
